// extracted by css-extract-rspack-plugin
var _1 = "iYbIGeRvlNSJIKGr9vFy6g--";
var _2 = "ut-jQg4uM9R6YGNXkPtkeg--";
export { _1 as "base", _2 as "fillViewport" }
